import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { InsuranceCompany } from "../_types/insurance-company";

@Injectable({
    providedIn: 'root',
})

export class InsuranceCompaniesService extends Service<InsuranceCompany> {
  public override type = 'insuranceCompanies';
  public override url = 'attendance/insuranceCompanies';   
  
  //habilita la cache para el metodo all
  public override CACHEABLE_METHODS: any = { all: true };
}
